'use client';
import React, { useEffect, useState } from 'react';
import { ChevronUp, ChevronDown, Bot, User, Search, Download, Trophy } from 'lucide-react';

interface WeeklyEntry {
  id: string;
  rank: number;
  name: string;
  type: 'bot' | 'player';
  score: number;
  peakSize: number;
  survivalTime: number;
  dotsCollected: number;
  absorbed: number;
  submittedAt: string;
}

function formatTime(s: number): string {
  const m = Math.floor(s / 60);
  const sec = s % 60;
  return `${m}m ${String(sec).padStart(2, '0')}s`;
}

const MOCK_WEEKLY: WeeklyEntry[] = [
  { id: 'w-001', rank: 1, name: 'APEX-NX7', type: 'bot', score: 284750, peakSize: 1240, survivalTime: 3847, dotsCollected: 9820, absorbed: 287, submittedAt: '2026-06-22' },
  { id: 'w-002', rank: 2, name: 'VoidPulse', type: 'bot', score: 241380, peakSize: 1087, survivalTime: 3421, dotsCollected: 8640, absorbed: 241, submittedAt: '2026-06-22' },
  { id: 'w-003', rank: 3, name: 'NeonDrifter', type: 'player', score: 198420, peakSize: 892, survivalTime: 2984, dotsCollected: 7280, absorbed: 198, submittedAt: '2026-06-21' },
  { id: 'w-004', rank: 4, name: 'Zyth-Prime', type: 'bot', score: 184930, peakSize: 834, survivalTime: 2740, dotsCollected: 6920, absorbed: 176, submittedAt: '2026-06-22' },
  { id: 'w-005', rank: 5, name: 'CyberCell', type: 'player', score: 172450, peakSize: 781, survivalTime: 2580, dotsCollected: 6480, absorbed: 162, submittedAt: '2026-06-21' },
  { id: 'w-006', rank: 6, name: 'Krell-9', type: 'bot', score: 159870, peakSize: 728, survivalTime: 2380, dotsCollected: 6020, absorbed: 149, submittedAt: '2026-06-20' },
  { id: 'w-007', rank: 7, name: 'GlitchCore', type: 'player', score: 148320, peakSize: 675, survivalTime: 2210, dotsCollected: 5680, absorbed: 137, submittedAt: '2026-06-22' },
  { id: 'w-008', rank: 8, name: 'OmenFlux', type: 'bot', score: 137890, peakSize: 622, survivalTime: 2040, dotsCollected: 5280, absorbed: 124, submittedAt: '2026-06-20' },
  { id: 'w-009', rank: 9, name: 'ArcFlux', type: 'player', score: 127460, peakSize: 569, survivalTime: 1920, dotsCollected: 4940, absorbed: 112, submittedAt: '2026-06-19' },
  { id: 'w-010', rank: 10, name: 'Vexor-X', type: 'bot', score: 118030, peakSize: 516, survivalTime: 1790, dotsCollected: 4560, absorbed: 100, submittedAt: '2026-06-21' },
  { id: 'w-011', rank: 11, name: 'LumaX', type: 'player', score: 109600, peakSize: 481, survivalTime: 1670, dotsCollected: 4240, absorbed: 89, submittedAt: '2026-06-20' },
  { id: 'w-012', rank: 12, name: 'NX-Glare', type: 'bot', score: 101170, peakSize: 446, survivalTime: 1560, dotsCollected: 3940, absorbed: 79, submittedAt: '2026-06-19' },
  { id: 'w-013', rank: 13, name: 'VoidHunter', type: 'player', score: 93840, peakSize: 411, survivalTime: 1450, dotsCollected: 3620, absorbed: 70, submittedAt: '2026-06-22' },
  { id: 'w-014', rank: 14, name: 'PulseCore', type: 'bot', score: 87210, peakSize: 376, survivalTime: 1340, dotsCollected: 3360, absorbed: 61, submittedAt: '2026-06-18' },
  { id: 'w-015', rank: 15, name: 'Lyra-88', type: 'bot', score: 81480, peakSize: 348, survivalTime: 1240, dotsCollected: 3080, absorbed: 53, submittedAt: '2026-06-21' },
  { id: 'w-016', rank: 16, name: 'NeonPulsar', type: 'player', score: 76250, peakSize: 320, survivalTime: 1150, dotsCollected: 2840, absorbed: 46, submittedAt: '2026-06-20' },
  { id: 'w-017', rank: 17, name: 'Dusk-Axon', type: 'bot', score: 71020, peakSize: 292, survivalTime: 1060, dotsCollected: 2600, absorbed: 39, submittedAt: '2026-06-19' },
  { id: 'w-018', rank: 18, name: 'CrystalOrb', type: 'player', score: 66290, peakSize: 268, survivalTime: 980, dotsCollected: 2380, absorbed: 33, submittedAt: '2026-06-22' },
  { id: 'w-019', rank: 19, name: 'Raze-Cyne', type: 'bot', score: 61560, peakSize: 244, survivalTime: 900, dotsCollected: 2180, absorbed: 27, submittedAt: '2026-06-18' },
  { id: 'w-020', rank: 20, name: 'PhotonCell', type: 'player', score: 57330, peakSize: 220, survivalTime: 830, dotsCollected: 1980, absorbed: 22, submittedAt: '2026-06-21' },
  { id: 'w-021', rank: 21, name: 'Elix-Prime', type: 'bot', score: 53100, peakSize: 199, survivalTime: 760, dotsCollected: 1800, absorbed: 17, submittedAt: '2026-06-20' },
  { id: 'w-022', rank: 22, name: 'ZeroFlux', type: 'player', score: 49370, peakSize: 182, survivalTime: 700, dotsCollected: 1640, absorbed: 13, submittedAt: '2026-06-17' },
  { id: 'w-023', rank: 23, name: 'FazeOrbit', type: 'bot', score: 45640, peakSize: 165, survivalTime: 640, dotsCollected: 1480, absorbed: 9, submittedAt: '2026-06-22' },
  { id: 'w-024', rank: 24, name: 'NebulaDrift', type: 'player', score: 42410, peakSize: 149, survivalTime: 590, dotsCollected: 1340, absorbed: 6, submittedAt: '2026-06-19' },
  { id: 'w-025', rank: 25, name: 'Grix-Nox', type: 'bot', score: 39180, peakSize: 133, survivalTime: 540, dotsCollected: 1220, absorbed: 4, submittedAt: '2026-06-21' },
  { id: 'w-026', rank: 26, name: 'PixelWave', type: 'player', score: 36450, peakSize: 120, survivalTime: 490, dotsCollected: 1100, absorbed: 2, submittedAt: '2026-06-20' },
  { id: 'w-027', rank: 27, name: 'HazeWave', type: 'bot', score: 33720, peakSize: 108, survivalTime: 450, dotsCollected: 990, absorbed: 1, submittedAt: '2026-06-18' },
  { id: 'w-028', rank: 28, name: 'FluxRider', type: 'player', score: 30990, peakSize: 97, survivalTime: 410, dotsCollected: 880, absorbed: 0, submittedAt: '2026-06-22' },
  { id: 'w-029', rank: 29, name: 'Izon-9X', type: 'bot', score: 28760, peakSize: 87, survivalTime: 380, dotsCollected: 780, absorbed: 0, submittedAt: '2026-06-17' },
  { id: 'w-030', rank: 30, name: 'StarCell', type: 'player', score: 26530, peakSize: 78, survivalTime: 350, dotsCollected: 690, absorbed: 0, submittedAt: '2026-06-21' },
];

type SortKey = 'rank' | 'score' | 'peakSize' | 'survivalTime' | 'dotsCollected' | 'absorbed';

const RankBadge = ({ rank }: { rank: number }) => {
  if (rank === 1) return <span className="inline-flex items-center justify-center w-7 h-7 rounded-full rank-badge-gold text-xs font-bold">1</span>;
  if (rank === 2) return <span className="inline-flex items-center justify-center w-7 h-7 rounded-full rank-badge-silver text-xs font-bold">2</span>;
  if (rank === 3) return <span className="inline-flex items-center justify-center w-7 h-7 rounded-full rank-badge-bronze text-xs font-bold">3</span>;
  return <span className="text-sm font-mono text-muted-foreground w-7 text-center inline-block">{rank}</span>;
};

export default function WeeklyLeaderboardTable() {
  const [entries, setEntries] = useState<WeeklyEntry[]>(MOCK_WEEKLY);
  const [sortKey, setSortKey] = useState<SortKey>('rank');
  const [sortDir, setSortDir] = useState<'asc' | 'desc'>('asc');
  const [search, setSearch] = useState('');
  const [filterType, setFilterType] = useState<'all' | 'player' | 'bot'>('all');
  const [page, setPage] = useState(1);
  const perPage = 15;

  useEffect(() => {
    // BACKEND INTEGRATION: GET /api/weekly-leaderboard?week=current
    // Merge localStorage entries with backend data
    try {
      const local = JSON.parse(localStorage.getItem('lunora_weekly') || '[]') as Array<{
        id: string; name: string; score: number; peakSize: number;
        survivalTime: number; dotsCollected: number; absorbed: number; submittedAt: string;
      }>;
      if (local.length > 0) {
        const localEntries: WeeklyEntry[] = local.map((e, i) => ({
          id: e.id,
          rank: i + 1,
          name: e.name,
          type: 'player' as const,
          score: e.score,
          peakSize: e.peakSize,
          survivalTime: e.survivalTime,
          dotsCollected: e.dotsCollected,
          absorbed: e.absorbed,
          submittedAt: e.submittedAt ? e.submittedAt.split('T')[0] : '2026-06-22',
        }));
        // Merge and deduplicate by id
        const combined = [...MOCK_WEEKLY, ...localEntries];
        const seen = new Set<string>();
        const deduped = combined.filter(e => { if (seen.has(e.id)) return false; seen.add(e.id); return true; });
        deduped.sort((a, b) => b.score - a.score);
        deduped.forEach((e, i) => { e.rank = i + 1; });
        setEntries(deduped);
      }
    } catch {
      // ignore
    }
  }, []);

  const handleSort = (key: SortKey) => {
    if (sortKey === key) setSortDir(d => d === 'asc' ? 'desc' : 'asc');
    else { setSortKey(key); setSortDir(key === 'rank' ? 'asc' : 'desc'); }
    setPage(1);
  };

  const filtered = entries
    .filter(e => e.name.toLowerCase().includes(search.toLowerCase()))
    .filter(e => filterType === 'all' || e.type === filterType)
    .sort((a, b) => {
      const av = a[sortKey], bv = b[sortKey];
      return sortDir === 'asc' ? (av < bv ? -1 : 1) : (av > bv ? -1 : 1);
    });

  const totalPages = Math.ceil(filtered.length / perPage);
  const paginated = filtered.slice((page - 1) * perPage, page * perPage);

  const SortBtn = ({ k, label }: { k: SortKey; label: string }) => (
    <button
      onClick={() => handleSort(k)}
      className="flex items-center gap-1 hover:text-foreground transition-colors group"
    >
      {label}
      {sortKey === k
        ? (sortDir === 'asc' ? <ChevronUp size={12} className="text-primary" /> : <ChevronDown size={12} className="text-primary" />)
        : <ChevronUp size={12} className="text-muted-foreground/30 group-hover:text-muted-foreground" />
      }
    </button>
  );

  return (
    <div className="stat-card p-0 overflow-hidden">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 px-5 py-4 border-b border-border">
        <div>
          <h2 className="text-base font-semibold text-foreground">This Week&apos;s Rankings</h2>
          <p className="text-xs text-muted-foreground mt-0.5">{filtered.length} total entries</p>
        </div>
        <div className="flex items-center gap-2">
          <div className="relative">
            <Search size={13} className="absolute left-2.5 top-1/2 -translate-y-1/2 text-muted-foreground" />
            <input
              type="text"
              placeholder="Search player..."
              value={search}
              onChange={e => { setSearch(e.target.value); setPage(1); }}
              className="bg-input border border-border rounded pl-8 pr-3 py-1.5 text-xs text-foreground placeholder-muted-foreground focus:outline-none focus:border-primary w-40"
            />
          </div>
          <div className="flex rounded border border-border overflow-hidden">
            {(['all', 'player', 'bot'] as const).map(t => (
              <button
                key={`filter-${t}`}
                onClick={() => { setFilterType(t); setPage(1); }}
                className={`px-2.5 py-1.5 text-xs font-medium transition-colors ${
                  filterType === t ? 'bg-primary/15 text-primary' : 'text-muted-foreground hover:text-foreground'
                }`}
              >
                {t === 'all' ? 'All' : t === 'player' ? 'Players' : 'AI'}
              </button>
            ))}
          </div>
          <button className="p-1.5 rounded border border-border text-muted-foreground hover:text-foreground transition-colors" title="Export leaderboard">
            <Download size={14} />
          </button>
        </div>
      </div>

      {/* Table */}
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-border bg-muted/20">
              <th className="px-4 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wide w-16">
                <SortBtn k="rank" label="Rank" />
              </th>
              <th className="px-4 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wide">Name</th>
              <th className="px-4 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wide">
                <SortBtn k="score" label="Score" />
              </th>
              <th className="px-4 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wide">
                <SortBtn k="peakSize" label="Peak Size" />
              </th>
              <th className="px-4 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wide">
                <SortBtn k="survivalTime" label="Survival" />
              </th>
              <th className="px-4 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wide">
                <SortBtn k="dotsCollected" label="Dots" />
              </th>
              <th className="px-4 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wide">
                <SortBtn k="absorbed" label="Absorbed" />
              </th>
              <th className="px-4 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wide">Date</th>
            </tr>
          </thead>
          <tbody>
            {paginated.map((entry, idx) => (
              <tr
                key={entry.id}
                className={`border-b border-border/50 transition-colors ${
                  idx % 2 === 0 ? 'bg-card' : 'bg-muted/10'
                } hover:bg-muted/30 ${entry.type === 'player' ? 'leaderboard-row-player' : ''}`}
              >
                <td className="px-4 py-3">
                  <RankBadge rank={entry.rank} />
                </td>
                <td className="px-4 py-3">
                  <div className="flex items-center gap-2">
                    {entry.type === 'player' ? (
                      <span className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded border border-primary/30 bg-primary/5 text-xs text-primary">
                        <User size={9} />
                      </span>
                    ) : (
                      <span className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded border border-border bg-muted/30 text-xs text-muted-foreground">
                        <Bot size={9} />
                      </span>
                    )}
                    <span className={`font-medium text-sm ${entry.type === 'player' ? 'text-primary' : 'text-foreground'}`}>
                      {entry.name}
                    </span>
                  </div>
                </td>
                <td className="px-4 py-3 font-mono text-sm font-bold text-yellow-400">
                  {entry.score.toLocaleString()}
                </td>
                <td className="px-4 py-3 font-mono text-sm text-primary">{entry.peakSize}</td>
                <td className="px-4 py-3 font-mono text-sm text-neon-green">{formatTime(entry.survivalTime)}</td>
                <td className="px-4 py-3 font-mono text-sm text-neon-cyan">{entry.dotsCollected.toLocaleString()}</td>
                <td className="px-4 py-3 font-mono text-sm text-neon-magenta">{entry.absorbed}</td>
                <td className="px-4 py-3 text-xs text-muted-foreground font-mono">{entry.submittedAt}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {filtered.length === 0 && (
        <div className="py-16 text-center">
          <Trophy size={36} className="mx-auto mb-3 text-muted-foreground/30" />
          <p className="text-sm text-muted-foreground">No entries match your search</p>
          <p className="text-xs text-muted-foreground/60 mt-1">Play a session and submit your score to appear here</p>
        </div>
      )}

      {/* Pagination */}
      {totalPages > 1 && (
        <div className="px-5 py-3 border-t border-border flex items-center justify-between">
          <span className="text-xs text-muted-foreground font-mono">
            Page {page} of {totalPages} — {filtered.length} entries
          </span>
          <div className="flex items-center gap-1">
            <button
              onClick={() => setPage(p => Math.max(1, p - 1))}
              disabled={page === 1}
              className="px-3 py-1.5 text-xs rounded border border-border text-muted-foreground hover:text-foreground disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
            >
              Prev
            </button>
            {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
              const pageNum = Math.max(1, Math.min(totalPages - 4, page - 2)) + i;
              return (
                <button
                  key={`page-${pageNum}`}
                  onClick={() => setPage(pageNum)}
                  className={`w-8 h-7 text-xs rounded border transition-colors ${
                    page === pageNum
                      ? 'border-primary/40 bg-primary/10 text-primary' :'border-border text-muted-foreground hover:text-foreground'
                  }`}
                >
                  {pageNum}
                </button>
              );
            })}
            <button
              onClick={() => setPage(p => Math.min(totalPages, p + 1))}
              disabled={page === totalPages}
              className="px-3 py-1.5 text-xs rounded border border-border text-muted-foreground hover:text-foreground disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
            >
              Next
            </button>
          </div>
        </div>
      )}
    </div>
  );
}